import type { IExercise } from '../exercises';

export const FOUR_WAY_EPISODE_01_MATERIALS: IExercise[] = [
  {
    "id": "course-20261008-four-way-01-01",
    "name": "弹力带肩部热身",
    "bodyPart": "warmup",
    "equipment": "resistance-band",
    "subCategory": "general",
    "tips": ["核心收紧，控制动作节奏", "全程保持肩胛骨稳定"],
    "sets": 2,
    "reps": "15",
    "rpe": 4,
    "restSeconds": 30,
    "isBodyweight": false,
    "isWarmup": true,
    "difficulty": "beginner",
    "targetMuscles": ["全身激活肌群"],
    "demoUrl": "/media/collections-20261008/demos/mobile-45da881ab44ee17e8a558272.mp4",
    "videoUrl": "/media/collections-20261008/videos/bff0d94506f7dccd9abc7d72.mp4",
    "source": "四分化训练 · 第1期",
    "isStretch": false,
    "demoStatus": "ready",
  },
  {
    "id": "course-20261008-four-way-01-02",
    "name": "前锯肌激活",
    "bodyPart": "warmup",
    "equipment": "bodyweight",
    "subCategory": "chest",
    "tips": ["俯卧撑位，肩胛骨前引再收回", "感受前锯肌发力，核心稳定不塌腰"],
    "sets": 2,
    "reps": "15",
    "rpe": 3,
    "restSeconds": 30,
    "isBodyweight": true,
    "isWarmup": true,
    "difficulty": "beginner",
    "targetMuscles": ["全身激活肌群"],
    "source": "四分化训练 · 第1期",
    "demoUrl": "/media/collections-20261008/demos/mobile-fa0bee91aca073915c175c01.mp4",
    "videoUrl": "/media/collections-20261008/videos/6c4d4784b7872813339f5a4f.mp4",
    "isStretch": false,
    "demoStatus": "ready",
  },
  {
    "id": "course-20261008-four-way-01-03",
    "name": "杠铃平板卧推",
    "bodyPart": "chest",
    "equipment": "barbell",
    "subCategory": "mid-chest",
    "tips": ["核心收紧，控制动作节奏", "全程保持肩胛骨稳定"],
    "sets": 4,
    "reps": "8-12",
    "rpe": 8,
    "restSeconds": 90,
    "isBodyweight": false,
    "difficulty": "advanced",
    "targetMuscles": ["胸大肌", "三角肌前束"],
    "demoUrl": "/media/collections-20261008/demos/mobile-0b1ec7353b931e8be4d1b73e.mp4",
    "videoUrl": "/media/collections-20261008/videos/reviewed-5d67f73cd223da2ec24a8b1c.mp4",
    "source": "四分化训练 · 第1期",
    "isWarmup": false,
    "isStretch": false,
    "demoStatus": "ready",
  },
  {
    "id": "course-20261008-four-way-01-04",
    "name": "上斜器械卧推",
    "bodyPart": "chest",
    "equipment": "machine",
    "subCategory": "upper-chest",
    "tips": ["器械上斜推胸", "顶峰收缩"],
    "sets": 3,
    "reps": "12-15",
    "rpe": 8,
    "restSeconds": 75,
    "isBodyweight": false,
    "demoUrl": "/media/collections-20261008/demos/mobile-39a07adf544bf0cac82bc7f2.mp4",
    "videoUrl": "/media/collections-20261008/videos/e791975ff6da697b77ad3079.mp4",
    "targetMuscles": ["上胸肌", "胸大肌", "三角肌前束", "肱三头肌"],
    "difficulty": "beginner",
    "source": "四分化训练 · 第1期",
    "isWarmup": false,
    "isStretch": false,
    "demoStatus": "ready",
  },
  {
    "id": "course-20261008-four-way-01-05",
    "name": "龙门架绳索夹胸",
    "bodyPart": "chest",
    "equipment": "cable",
    "subCategory": "inner-chest",
    "tips": ["核心收紧，控制动作节奏", "全程保持肩胛骨稳定"],
    "sets": 3,
    "reps": "12-15",
    "rpe": 8,
    "restSeconds": 60,
    "isBodyweight": false,
    "difficulty": "advanced",
    "targetMuscles": ["胸大肌中缝", "前锯肌"],
    "demoUrl": "/media/collections-20261008/demos/mobile-298054dfed84df1720090333.mp4",
    "videoUrl": "/media/collections-20261008/videos/836f8556372101473db899ca.mp4",
    "source": "四分化训练 · 第1期",
    "isWarmup": false,
    "isStretch": false,
    "demoStatus": "ready",
  },
  {
    "id": "course-20261008-four-way-01-06",
    "name": "站姿实力推",
    "bodyPart": "shoulders",
    "equipment": "barbell",
    "subCategory": "front-deltoid",
    "tips": ["核心收紧", "推举至头顶"],
    "sets": 3,
    "reps": "12-15",
    "rpe": 8,
    "restSeconds": 75,
    "isBodyweight": false,
    "demoUrl": "/media/collections-20261008/demos/mobile-6149fe31e542709f9a4beb9c.mp4",
    "videoUrl": "/media/collections-20261008/videos/1d236fd47c5b322b80a65a7a.mp4",
    "targetMuscles": ["三角肌前束", "三角肌中束", "肱三头肌"],
    "difficulty": "intermediate",
    "source": "四分化训练 · 第1期",
    "isWarmup": false,
    "isStretch": false,
    "demoStatus": "ready",
  },
  {
    "id": "course-20261008-four-way-01-07",
    "name": "龙门架颈后臂屈伸",
    "bodyPart": "arms",
    "equipment": "cable",
    "subCategory": "triceps",
    "tips": ["核心收紧，控制动作节奏", "全程保持肩胛骨稳定"],
    "sets": 3,
    "reps": "12-15",
    "rpe": 8,
    "restSeconds": 60,
    "isBodyweight": false,
    "difficulty": "advanced",
    "targetMuscles": ["肱三头肌", "肘肌"],
    "demoUrl": "/media/collections-20261008/demos/mobile-0164981aa7052c730160101a.mp4",
    "videoUrl": "/media/collections-20261008/videos/5c081475d592306a956a1ab7.mp4",
    "source": "四分化训练 · 第1期",
    "isWarmup": false,
    "isStretch": false,
    "demoStatus": "ready",
  },
];
